import React from "react";
import useEditorAccess from "../../../hooks/useEditorAccess.hook";
import useFeatureFlag from "../../../hooks/useFeatureFlag.hook";
import { FEATURE_MY_DRAFTS } from "../../../utlities/featureFlags";
import Overview from "./Overview.page";
import DraftsList from "./DraftsList.page";

/**
 * Editor index route. When the My Drafts feature is enabled, authenticated users with editor access
 * land on their "My Draft ACRs" list (the primary way to resume work, GSAACR-356). Anonymous /
 * unauthorized users — and everyone when the feature is gated off — see the read-only Overview
 * introduction, which is the only publicly exposed editor page.
 */
export default function EditorIndex() {
  const hasEditorAccess = useEditorAccess();
  const myDraftsEnabled = useFeatureFlag(FEATURE_MY_DRAFTS);
  return hasEditorAccess && myDraftsEnabled ? <DraftsList /> : <Overview />;
}
